var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('a-row',{attrs:{"gutter":[16, 16]}},_vm._l((_vm.dorms),function(dorm){return _c('a-col',{key:dorm.dormId,attrs:{"lg":24,"md":24,"sm":24,"xl":24,"xs":24,"xxl":24}},[_c('Dorm',{attrs:{"dorm":dorm}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }